import getConfig from "next/config";

/**
 * Returns an error message for a failed fetch request.
 *
 * @param thing - The thing being requested.
 * @param system - The system on which the request was made.
 * @param url - The URL of the request (optional).
 * @returns The error message.
 */
const getFetchError = (thing: string, system: string, url: string = "") => {
    const { publicRuntimeConfig: { appName } } = getConfig();
    return `${appName} was unable to request ${thing} on the ${system}${url ? ` ${url}` : ""}.`;
};

export {
    getFetchError
};
